// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"c2bbfecf","80":"32310128","229":"3e83723c","393":"3f680ae8","415":"56e0bed0","787":"7892757c","936":"e22a7f90"}[chunkId] + ".chunk.js";
};